import * as React from "react";

const IconLogo: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" {...props}>
      <g clipPath="url(#clip0_292_980)">
        <path
          d="M27.6152 13.6921V16.9228C27.6152 17.8459 29.4614 17.8459 29.4614 16.9228V13.6921C29.4614 12.769 27.6152 12.769 27.6152 13.6921Z"
          fill="#3F3452"
        />
        <path
          d="M19.4276 16.9414L21.3753 20.006C21.9384 20.8829 23.4338 20.0891 22.8799 19.2122L20.9322 16.1475C20.3692 15.2706 18.8738 16.0645 19.4276 16.9414ZM20.1753 16.5445L22.123 19.6091L20.1753 16.5445Z"
          fill="#3F3452"
        />
        <path
          d="M14.9416 21.4275C14.0647 20.8737 13.2709 22.3506 14.1478 22.9321L17.2124 24.8798C18.0893 25.4337 18.8832 23.9567 18.0062 23.3752L14.9416 21.4275ZM14.5447 22.1752L17.6093 24.1229L14.5447 22.1752Z"
          fill="#3F3452"
        />
        <path
          d="M11.6923 31.4614H14.9231C15.8462 31.4614 15.8462 29.6152 14.9231 29.6152H11.6923C10.7692 29.6152 10.7692 31.4614 11.6923 31.4614Z"
          fill="#3F3452"
        />
        <path
          d="M44.4612 29.6152H41.2304C40.3073 29.6152 40.3073 31.4614 41.2304 31.4614H44.4612C45.3842 31.4614 45.3842 29.6152 44.4612 29.6152Z"
          fill="#3F3452"
        />
        <path
          d="M42.1352 21.4368L39.0706 23.3752C38.1937 23.9383 38.9876 25.4337 39.8645 24.8798L42.9291 22.9321C43.806 22.3691 43.0122 20.8644 42.1352 21.4368ZM39.4676 24.1229L42.5322 22.2306L39.4676 24.1229Z"
          fill="#3F3452"
        />
        <path
          d="M36.145 16.1475L34.1973 19.2122C33.6434 20.0891 35.1203 20.8829 35.7019 20.006L37.6496 16.9414C38.2034 16.0645 36.6988 15.2706 36.145 16.1475ZM34.945 19.6091L36.8927 16.5445L34.945 19.6091Z"
          fill="#3F3452"
        />
        <path
          d="M13.7688 37.9229H43.3072C43.5521 37.9229 43.7868 38.0201 43.96 38.1932C44.1331 38.3663 44.2303 38.6011 44.2303 38.8459C44.2303 39.0907 44.1331 39.3255 43.96 39.4986C43.7868 39.6718 43.5521 39.769 43.3072 39.769H13.7688C13.524 39.769 13.2892 39.6718 13.1161 39.4986C12.943 39.3255 12.8457 39.0907 12.8457 38.8459C12.8457 38.6011 12.943 38.3663 13.1161 38.1932C13.2892 38.0201 13.524 37.9229 13.7688 37.9229V37.9229Z"
          fill="#3F3452"
        />
        <path
          d="M11.9231 34.2305H44.2308C44.4756 34.2305 44.7104 34.3277 44.8835 34.5008C45.0566 34.6739 45.1538 34.9087 45.1538 35.1535C45.1538 35.3984 45.0566 35.6331 44.8835 35.8063C44.7104 35.9794 44.4756 36.0766 44.2308 36.0766H11.9231C11.6783 36.0766 11.4435 35.9794 11.2704 35.8063C11.0973 35.6331 11 35.3984 11 35.1535C11 34.9087 11.0973 34.6739 11.2704 34.5008C11.4435 34.3277 11.6783 34.2305 11.9231 34.2305V34.2305Z"
          fill="#3F3452"
        />
        <path
          d="M22.0774 40.6921H34.0774C34.3222 40.6921 34.557 40.7894 34.7301 40.9625C34.9032 41.1356 35.0005 41.3704 35.0005 41.6152C35.0005 41.86 34.9032 42.0948 34.7301 42.2679C34.557 42.441 34.3222 42.5383 34.0774 42.5383H22.0774C21.8326 42.5383 21.5978 42.441 21.4247 42.2679C21.2515 42.0948 21.1543 41.86 21.1543 41.6152C21.1543 41.3704 21.2515 41.1356 21.4247 40.9625C21.5978 40.7894 21.8326 40.6921 22.0774 40.6921Z"
          fill="#3F3452"
        />
        <path
          d="M38.6925 29.8275C38.6307 27.909 37.9869 26.0546 36.8464 24.5106C35.6251 22.8636 33.9365 21.6221 32.0002 20.9475C30.0346 20.2734 27.9139 20.1932 25.9029 20.7169C23.892 21.2406 22.0798 22.3449 20.6925 23.8921C19.4771 25.2926 18.7018 27.0205 18.4638 28.8595C18.2257 30.6984 18.5354 32.5668 19.3541 34.2306H21.1541C20.3687 32.9688 19.9524 31.5122 19.9524 30.026C19.9524 28.5397 20.3687 27.0832 21.1541 25.8214C22.1151 24.3723 23.4833 23.2399 25.0863 22.5665C26.6894 21.8931 28.4558 21.7088 30.1633 22.0367C32.0849 22.4023 33.8276 23.4037 35.111 24.8798C36.3112 26.2567 37.0049 28.0024 37.0772 29.8275V30.7506C37.0458 31.9993 36.6442 33.2105 35.9233 34.2306H37.6772C38.3864 33.1331 38.7408 31.8441 38.6925 30.5383V29.8275Z"
          fill="#3F3452"
        />
      </g>
      <defs>
        <clipPath id="clip0_292_980">
          <rect
            width="34.1538"
            height="29.5385"
            fill="white"
            transform="translate(11 12.9998)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export { IconLogo };
